export default __webpack_public_path__ + "static/mituanniaLogo-c0c7d54f04557b56432afc6aa49d8552.png";